import { VariantProvider } from './context/variant-context';
import { VariantListPageContent } from './components/variant-list-page-content';

export default function VariantListPage() {
  return (
    <VariantProvider>
      <VariantListPageContent />
    </VariantProvider>
  );
}
